import React, { useState, useEffect } from "react";
import { Button, Flex, Text, UnstyledButton, Modal } from "@mantine/core";
import axios from "axios";
import toast from "react-hot-toast";
import { IconCamera } from "@tabler/icons-react";
import { useQueryClient } from "@tanstack/react-query";
import { SnapshotForm } from "./SnapshotView";
import entityIcon from "@util/entityIcon";

export default function ReportSnapshotCreate({
  reqData,
  recipeId,
  defaultTitle,
}) {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const queryClient = useQueryClient();

  function onSubmit() {
    const req = {
      ...reqData,
    };

    setLoading(true);

    axios
      .post(`/report-recipes/save-snapshot/`, req)
      .then(() => {
        queryClient.invalidateQueries([`snapshots`]);
        toast.success("Saved");
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err);
        setLoading(false);
      });
  }

  return (
    <Flex justify="flex-start">
      <UnstyledButton onClick={() => setOpen(true)}>
        <Flex gap="xs" align="center">
          {entityIcon.snapshot()}
          <Text fw={600} size="sm">
            Take Snapshot
          </Text>
        </Flex>
      </UnstyledButton>
      <Modal opened={open} onClose={() => setOpen(false)}>
        <SnapshotForm
          id={null}
          title={""}
          defaultTitle={defaultTitle}
          description={""}
          onSuccess={() => {
            setOpen(false);
            queryClient.invalidateQueries([`snapshots`]);
          }}
          reqData={reqData}
        />
      </Modal>
    </Flex>
  );
}
